import Slider from 'react-slick';
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import ReactStars from 'react-rating-stars-component';
import { createNotification } from 'react-redux-notify';

import { utilitiesServiceUrl } from '../../../helpers/constants/api';
import { getErrorNotificationMessage } from '../../helper/NotificationMessage';

const endQuote = "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/endQuote.png";
const startQuote = "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/startQuote.png";

const Testimonials = () => {
  const dispatch = useDispatch();

  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const [records, setRecords] = useState([]);

  useEffect(() => {
    fetchRecords();
  }, [])

  const fetchRecords = async () => {
    try {
      const response = await fetch(`${utilitiesServiceUrl}landing-page/testimonials`);
      const data = await response.json();
      setRecords(data);
    } catch (error) {
      console.error('Fetching testimonials error', error);
      dispatch(createNotification(getErrorNotificationMessage('Unable to fetch testimonials.')));
    }
  };

  return (
    records && records.length > 0 && (
      <div className='testimonial-bg  padding-y68 pb-md-3 pb-2'>
        <div className='container'>
          <div className='heading-box text-center'>
            <div className='section-title' data-test='testimonial-title'>
              TESTIMONIAL
            </div>
            <div className='heading-title'>What People Say?</div>
          </div>

          <div className='testimonial-slider'>
            <Slider
              asNavFor={nav1}
              ref={(slider2) => setNav2(slider2)}
              slidesToShow={3}
              swipeToSlide={false}
              focusOnSelect={false}
              centerMode={true}
              centerPadding='0px'
            >
              {records.map((review) => {
                return (
                  <div className='slide-item small-slide' key={review?.id}>
                    <img
                      src={review?.picture}
                      className='pre-next-img'
                      alt='icon'
                    />
                  </div>
                );
              })}
            </Slider>
          </div>
          <Slider
            asNavFor={nav2}
            arrows={false}
            swipeToSlide={false}
            focusOnSelect={false}
            ref={(slider1) => setNav1(slider1)}
          >
            {records.map((review) => {
              return (
                <div
                  className='d-flex flex-column justify-content-center align-items-center'
                  key={review?.id}
                >
                  <div className='people-name'>{review?.name}</div>
                  <div className='people-sub'>{review?.about}</div>
                  <div className='d-flex flex-row justify-content-center'>
                    <ReactStars
                      count={5}
                      size={30}
                      isHalf={true}
                      value={review?.rating}
                      edit={false}
                      activeColor='#ffd700'
                    />
                  </div>
                  <div className='reviews text-center'>
                    <img
                      src={startQuote}
                      className='left-quote'
                      alt='Quote'
                    />
                    <p> {review?.review}</p>
                    <img src={endQuote} className='right-quote' alt='Quote' />
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    )
  )
}

Testimonials.propTypes = {
};

export default Testimonials;
